export const buttonsDescriptionData = [ 
    {
        code:".btn",
        text:"class for Bootstrap state buttons"
    },
    {
        code:".flat-btn",
        text:"class for Flate buttons"
    },
    {
        code:".edge-btn",
        text:"class for Edge buttons"
    },
    {
        code:".btn-lg , .btn-sm , .btn-xs",
        text:"class for Different size button "
    },
    {
        code:".disabled ",
        text:"class or ",
        code1:"disabled",
        text1:" attribute for Disabled state"
    },
    {
        code:".btn-outline-*",
        text:"class for Border buttons"
    },
    {
        code:".btn-outline-*-2x",
        text:"class for Bold Outline button"
    },
    {
        code:".btn-light-*",
        text:"class for Light Background Color."
    },
    {
        code:".btn-*-gradient",
        text:"class for gradient button"
    }
]

export const buttonsStyleTabData = [
    {
        title:"Default Buttons",
        id:"1"
    },
    {
        title:"Flat Buttons",
        id:"2"
    },
    {
        title:"Edge Buttons",
        id:"3"
    },
    {
        title:"Raised Buttons",
        id:"4"
    },
    {
        title:"Outline Buttons",
        id:"5"
    },
    {
        title:"Gradient Buttons",
        id:"6"
    }
]

export const defaultTabContentData = [
    {
        title:"Primary",
        tooltip:"btn btn-primary",
        color:"primary"
    },
    {
        title:"Secondary",
        tooltip:"btn btn-secondary",
        color:"secondary"
    },
    {
        title:"Tertiary",
        tooltip:"btn btn-tertiary",
        color:"tertiary"
    },
    {
        title:"Success",
        tooltip:"btn btn-success",
        color:"success"
    },
    {
        title:"Info",
        tooltip:"btn btn-info",
        color:"info"
    },
    {
        title:"Warning",
        tooltip:"btn btn-warning",
        color:"warning"
    },
    {
        title:"Danger",
        tooltip:"btn btn-danger",
        color:"danger"
    },
    {
        title:"Light",
        tooltip:"btn btn-light",
        color:"light"
    },
    {
        title:"Dark",
        tooltip:"btn btn-dark",
        color:"dark"
    }
]

export const buttonsStyleTabContentData = [
    {
        id:"1",
        class:"",
        data:defaultTabContentData
    },
    {
        id:"2",
        class:"flat-btn",
        data:defaultTabContentData
    },
    {
        id:"3",
        class:"edge-btn",
        data:defaultTabContentData
    },
    {
        id:"4",
        class:"btn-raised-primary",
        data:defaultTabContentData
    },
    {
        id:"5",
        outlines:true,
        data:defaultTabContentData
    },
    {
        id:"6",
        gradien:true,
        data:defaultTabContentData
    }
]

export const buttonsSizeTabData = [
    {
        title:"Default Size",
        id:"1"
    },
    {
        title:"Large Buttons",
        id:"2"
    },
    {
        title:"Small Buttons",
        id:"3"
    },
    {
        title:"Extra Small",
        id:"4"
    }
]

export const buttonsSizeTabContentData = [
    {
        id:"1",
        class:"",
        data:defaultTabContentData
    },
    {
        id:"2",
        class:"lg",
        data:defaultTabContentData
    },
    {
        id:"3",
        class:"sm",
        data:defaultTabContentData
    },
    {
        id:"4",
        class:"xs",
        data:defaultTabContentData
    }
]